module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-notes"
  }, [_c('icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.$t('tooltip.roster.tools.notes')),
      expression: "$t('tooltip.roster.tools.notes')"
    }],
    attrs: {
      "name": "info"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    attrs: {
      "placeholder": _vm.$t('tooltip.roster.tools.notes'),
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "keydown": _vm.handleKeys,
      "focus": _vm.focus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.item.notes) ? _c('a', {
    staticClass: "remove btn btn--red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.remove()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.delete')))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn--green",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.button.save')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ff5c41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Notes.vue
// module id = 586
// module chunks = 234